import { Typography } from "@stardust-ds/react"
import RcmpAlertIcon from "../../../assets/icons/AlertIcon"
import RcmpModalAdd from "../../molecules/ModalAdd"
import styles from "./index.module.scss"
import RcmpLoading from "../../atoms/Loading"

export default function RcmpModalInfo(props) {
  const {
    fnHandleCancel,
    bIsOpen,
    title,
    buttonCancelText,
    buttonSaveText,
    description,
    fnHandleConfirm,
    size,
    onlyText = false,
    oResponse,
    oButtonCancelProps,
    oButtonSaveProps,
    subText,
    ...oRest
  } = props

  const oButtonCancelPropsFormated = {
    ...oButtonCancelProps,
    style: {
      ...(oButtonCancelProps?.style || {}),
      display: oResponse?.loading
        ? "none"
        : oButtonCancelProps?.style?.display || "block",
    },
  }

  const oButtonSavePropsFormated = {
    ...oButtonSaveProps,
    style: {
      ...(oButtonSaveProps?.style || {}),
      display: oResponse?.loading ? "none" : oButtonSaveProps?.style?.display || "block",
    },
  }

  return (
    <RcmpModalAdd
      isOpen={bIsOpen}
      buttonCancelText={buttonCancelText}
      buttonSaveText={buttonSaveText}
      title={title}
      fnHandleCancel={fnHandleCancel}
      fnHandleConfirm={fnHandleConfirm}
      buttonType={"button"}
      size={size}
      oButtonCancelProps={oButtonCancelPropsFormated}
      oButtonSaveProps={oButtonSavePropsFormated}
      bIsInfo={true}
      {...oRest}
    >
      <div className={styles.modalInfoContent}>
        {oResponse?.loading ? (
          <RcmpLoading className={styles.modalInfoLoading} bShow={true} />
        ) : (
          <>
            {!onlyText && <RcmpAlertIcon fill={"#FFAE00"} />}
            <div className={styles.textContainer}>
              <p className={styles.titleTextStyle}>{description}</p>
              <p className={styles.subTextStyle}>{subText}</p>
            </div>
          </>
        )}
      </div>
    </RcmpModalAdd>
  )
}
